import WorstPerformer from './worstPerformer.png';
import BestPerformer from './bestPerformer.png';
import { colors } from '../../../colors';
import { useDimensions } from '../../../hooks/useDimensions';

const WhichSubscription1 = () => {
  const { dimensions: rootDimensions, ref: rootRef } = useDimensions();

  const chartWidth = ((rootDimensions?.width ?? 0) / 2) * 0.9;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        width: '100%',
        justifyContent: 'space-evenly',
      }}
      ref={rootRef}
    >
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p style={{ color: colors.white, fontSize: 28, margin: 0 }}>
          Worst Performer
        </p>
        <img
          src={WorstPerformer}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.7}
        />
      </div>
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p style={{ color: colors.white, fontSize: 28, margin: 0 }}>
          Best Performer
        </p>
        <img
          src={BestPerformer}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.7}
        />
      </div>
    </div>
  );
};

export default WhichSubscription1;
